import { ProductWarrantyVariant } from '@/types/Product'
import FederalHolidaysArray from '@/data/federalHolidays.json'

const TIMEZONE_OFFSET = -5 * 60 * 60 * 1000 // Using 5 hours behind UTC, reasonable

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const toIsoDateOnlyNoTime = (date: Date) => new Date(date.getTime() + TIMEZONE_OFFSET).toISOString().slice(0, 10)
const FederalHoliday = FederalHolidaysArray
  .reduce((hash: { [key: string]: boolean; }, next: string) => {
    hash[next] = true
    return hash
  }, {})

const weekends = [true, false, false, false, false, false, true]

const isBusinessDay = (date: Date) => !FederalHoliday[toIsoDateOnlyNoTime(date)]
  && !weekends[date.getDay()]

const toEstimatedDateFormat = (date: Date) => `${months[date.getMonth()]} ${date.getDate()}`
const toTwoDigits = (number: number) => (
  ((number / 10) < 1)
    ? `0${number}`
    : `${number}`
)

// mm/dd/yyyy-mm/dd/yyyy
const toEstimatedDateFormatWithYear = (date: Date) => `${toTwoDigits(date.getMonth() + 1)}/${toTwoDigits(date.getDate())}/${date.getFullYear()}`

const dayAdder = (startingDate: Date) => {
  return startingDate
}

// deduct from number of addable days if and only if it is a business day
// but ALWAYS increment the date on calendar.
const addDaysToDate = (B: string, D: number) => {
  let counter = D
  const incrementingDate = new Date(B)
  while (counter > 0) {
    incrementingDate.setDate(incrementingDate.getDate() + 1)
    if (isBusinessDay(incrementingDate)) {
      counter -= 1
    }
  }
  return incrementingDate
}

const variantShipsInOneMonth = (variant: ProductWarrantyVariant):boolean => {
    try {
      return parseInt(variant?.estimated_min_delivery_days) <= 31 && !variant?.baseDateForDeliveryCalculation
    } catch (e) {
      return true
    }
  }

export { addDaysToDate, toEstimatedDateFormat, toEstimatedDateFormatWithYear, variantShipsInOneMonth }